import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { isLoggedIn } from '../../../../data/user.model';
import { redirectToLogin } from '../../../../actions/auth';
import { toggleFavouriteRecipe } from '../../../../api/ECOM/toggleFavouriteRecipe.api';
import { useI18N } from '../../../my-puratos/hoc/withI18N';
import { googleEvents } from '../../../../utils/googleEvents';
import { GA4PageType } from '../../../../analytics/ga4/types/page';

const toggleFavorite = async (recipe) => {
    try {
        const response = await toggleFavouriteRecipe({
            RecipeId: recipe.id,
            RecipeURL: recipe.url,
        });
        return response.successCode === 'True';
    } catch (error) {
        console.error('Error toggling favorite:', error);
        return false;
    }
};

export const ProductCardFavoriteRecipe = ({ recipe, favoriteRecipe }) => {
    const dispatch = useDispatch();
    const [isFavorite, setIsFavorite] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const translate = useI18N();

    useEffect(() => {
        setIsFavorite(favoriteRecipe);
    }, [favoriteRecipe]);

    const handleToggleFavorite = async () => {
        if (!isLoggedIn()) {
            dispatch(redirectToLogin());
            return;
        }

        setIsLoading(true);

        try {
            const success = await toggleFavorite(recipe);
            if (success) {
                if (!isFavorite) {
                    googleEvents.recipeLike({recipe_name: recipe.referenceTitle, website_section: GA4PageType.product});
                }
                setIsFavorite(!isFavorite);
            } else {
                console.error('Failed to toggle favorite. Check API response.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <button
            aria-label={translate('Add "{0}" to favorite recipes', [
                recipe.referenceTitle,
            ])}
            onClick={handleToggleFavorite}
            disabled={isLoading}
            className={`btn-fav ${!isFavorite ? 'btn-fav-empty' : ''} ${
                isLoading ? 'btn-fav-disabled' : ''
            }`}
        />
    );
};
